export default {
  id: null,
  empresaID: null,
  quadroFuncionarioID: null,
  funcionarioID: null,
  admissao: null,
  situacao: null,
  dataExperiencia1: null,
  dataExperiencia2: null,
  avisoPrevio: null,
  ferias: null,
  dataAfastamento: null,
  refeicaoQuantidade: null,
  refeicaoValorUnitario: null,
  valeAlimentacao: null,
  cafeManhaValor: null,
  valeTransporteQuantidade: null,
  valeTransporteValorUnitario: null,
  observacao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/business/employeemodel.js